// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previous-question-button-styles {
  background: #f5f7fa !important;
  color: black !important;
  font-family: Plus Jakarta Sans;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: left !important;
  padding: 0px 16px 0px 16px !important;
  border: none !important;
}

.previous-question-button-styles:hover {
  font-weight: 900;
  background-color: #d0d8e3 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentPages/TopicwiseTest/styles.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oCAAA;AACF","sourcesContent":[".previous-question-button-styles {\n  background: #f5f7fa !important;\n  color: black !important;\n  font-family: Plus Jakarta Sans;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: left !important;\n  padding: 0px 16px 0px 16px !important;\n  border: none !important;\n}\n\n.previous-question-button-styles:hover {\n  font-weight: 900;\n  background-color: #d0d8e3 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
